import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from './ModalVisualizationBody.module.css';
import { useModalVisualizationBody } from './useModalVisualizationBody';
import { VisualizationsList } from './VisualizationsList/VisualizationsList';
import { DnD } from '../../../../../components/newUI/DnD/DnD';

interface ModalVisualizationBodyProps {
    classes?: string;
}

export const ModalVisualizationBody = memo(({ classes }: ModalVisualizationBodyProps) => {
    const { visualizations, onImageChange } = useModalVisualizationBody();

    const { t } = useTranslation();

    return (
        <div className={classNames(cls.ModalVisualizationBody, [classes])}>
            <DnD
                addImageTitle={t('ModalVisualizationBody.return.addImageTitle')}
                classes={cls.dnd}
                button={t('ModalVisualizationBody.return.button')}
                onImageChange={onImageChange}
                dragClasses={cls.drag}
            >
                {visualizations.length ? (
                    <VisualizationsList visualizations={visualizations} />
                ) : (
                    <div className={cls.emptyImages}>
                        <span>
                            {t('ModalVisualizationBody.return.emptyImages.part1')}
                            <br />
                            {t('ModalVisualizationBody.return.emptyImages.part2')}
                        </span>
                    </div>
                )}
            </DnD>
        </div>
    );
});
